function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define("ReedsyExitModal", [], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReedsyExitModal = t() : e.ReedsyExitModal = t();
}(self, function () {
  return e = {
    64: function _(e) {
      function t(e, t) {
        for (var s = 0; s < t.length; s++) {
          var n = t[s];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      var s = Object.freeze({
          days: "days",
          hours: "hours",
          minutes: "minutes",
          weeks: "weeks"
        }),
        n = {
          activateAfterMs: 500,
          aggressive: !1,
          callback: null,
          classes: {
            hidden: null,
            visible: null
          },
          data: null,
          delayMs: 0,
          key: null,
          maxTimes: 1,
          reenableAfter: {
            type: s.weeks,
            value: 2
          },
          reenableOnNewSession: !1
        },
        i = function () {
          function e(t, s) {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), this._element = document.getElementById(t), this._element || (this._element = document.querySelector(t)), this._element ? (this._config = Object.assign({}, n, s), this._delayed = null, this._defaultKey = t.replace(/\s/g, ""), this._doc = document.documentElement, this._boundFns = {
              keyDown: this.keyDownPerformed.bind(this),
              mouseEnter: this.mouseEnterPerformed.bind(this),
              mouseLeave: this.mouseLeavePerformed.bind(this),
              showModal: this.show.bind(this)
            }, this.enable()) : console.warn("ExitModal: element ".concat(t, " not found."));
          }
          var i, o;
          return i = e, o = [{
            key: "disable",
            value: function value() {
              this._isDisabled = !0, this.removeEventListeners();
            }
          }, {
            key: "destroy",
            value: function value() {
              this.disable();
            }
          }, {
            key: "enable",
            value: function value() {
              this.setInitialState(), this._isDisabled || setTimeout(this.addEventListeners.bind(this), this._config.activateAfterMs);
            }
          }, {
            key: "getLocalStorageCountKey",
            value: function value() {
              var e = this.getModalKey();
              return "".concat(e, "-count");
            }
          }, {
            key: "getLocalStorageShownDateKey",
            value: function value() {
              var e = this.getModalKey();
              return "".concat(e, "-shown-date");
            }
          }, {
            key: "getModalKey",
            value: function value() {
              return this._config.key || this._defaultKey;
            }
          }, {
            key: "getReenableAfterMs",
            value: function value() {
              if (!this._config.reenableAfter || !this._config.reenableAfter.type) return null;
              if (!s[this._config.reenableAfter.type]) return null;
              if (!this._config.reenableAfter.value || this._config.reenableAfter.value <= 0) return null;
              switch (this._config.reenableAfter.type) {
                case s.days:
                  return 864e5 * this._config.reenableAfter.value;
                case s.hours:
                  return 36e5 * this._config.reenableAfter.value;
                case s.minutes:
                  return 6e4 * this._config.reenableAfter.value;
                case s.weeks:
                  return 6048e5 * this._config.reenableAfter.value;
              }
            }
          }, {
            key: "getSessionStorageIdKey",
            value: function value() {
              var e = this.getModalKey();
              return "".concat(e, "-session-displayed");
            }
          }, {
            key: "getStoredCount",
            value: function value() {
              var e = this.getLocalStorageCountKey(),
                t = parseInt(localStorage.getItem(e));
              return "number" != typeof t || isNaN(t) ? 0 : t;
            }
          }, {
            key: "hide",
            value: function value() {
              this._config.classes.visible && this._element.classList.remove(this._config.classes.visible), this._config.classes.hidden ? this._element.classList.add(this._config.classes.hidden) : this._element.style.display = "none";
            }
          }, {
            key: "saveSessionId",
            value: function value() {
              var e = this.getSessionStorageIdKey();
              sessionStorage[e] = "true";
            }
          }, {
            key: "saveShownDate",
            value: function value() {
              var e = this.getLocalStorageShownDateKey();
              localStorage.setItem(e, Date.now());
            }
          }, {
            key: "setInitialState",
            value: function value() {
              if (this.hide(), this._isDisabled = !1, !0 !== this._config.aggressive && this.getStoredCount() >= this._config.maxTimes) {
                var e = this.shouldReactivateOnNewSession(),
                  t = this.shouldRectivateAfterPeriod();
                if (e || t) {
                  var s = this.getLocalStorageCountKey();
                  localStorage.removeItem(s);
                } else this._isDisabled = !0;
              }
            }
          }, {
            key: "shouldRectivateAfterPeriod",
            value: function value() {
              var e = this.getReenableAfterMs();
              if (null === e) return !1;
              var t = this.getLocalStorageShownDateKey(),
                s = localStorage.getItem(t);
              if (!s) return !0;
              try {
                var n = new Date(parseInt(s)),
                  i = Date.now() - n;
                if (isNaN(i)) return !0;
                var o = i >= e;
                return o && localStorage.removeItem(t), o;
              } catch (e) {
                return !0;
              }
            }
          }, {
            key: "shouldReactivateOnNewSession",
            value: function value() {
              if (!0 !== this._config.reenableOnNewSession) return !1;
              var e = this.getSessionStorageIdKey();
              return "true" !== sessionStorage[e];
            }
          }, {
            key: "show",
            value: function value() {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              if (e || !this._isDisabled) {
                this._config.classes.hidden && this._element.classList.remove(this._config.classes.hidden), this._config.classes.visible ? this._element.classList.add(this._config.classes.visible) : this._element.style.display = "block";
                var t = this.getStoredCount(),
                  s = t + 1,
                  n = this.getLocalStorageCountKey();
                if (localStorage.setItem(n, s), this.saveShownDate(), this.saveSessionId(), "function" == typeof this._config.callback) {
                  var i = this.getModalKey();
                  this._config.callback(i, this._config.data);
                }
                this.destroy();
              }
            }
          }, {
            key: "addEventListeners",
            value: function value() {
              this._isDisabled || (this._doc.addEventListener("keydown", this._boundFns.keyDown), this._doc.addEventListener("mouseenter", this._boundFns.mouseEnter), this._doc.addEventListener("mouseleave", this._boundFns.mouseLeave));
            }
          }, {
            key: "keyDownPerformed",
            value: function value(e) {
              e.metaKey && 76 === e.keyCode && (this._delayed = setTimeout(this._boundFns.showModal, this._config.delayMs));
            }
          }, {
            key: "mouseEnterPerformed",
            value: function value(e) {
              this._delayed && (clearTimeout(this._delayed), this._delayed = null);
            }
          }, {
            key: "mouseLeavePerformed",
            value: function value(e) {
              this._delayed = setTimeout(this._boundFns.showModal, this._config.delayMs);
            }
          }, {
            key: "removeEventListeners",
            value: function value() {
              this._doc.removeEventListener("keydown", this._boundFns.keyDown), this._doc.removeEventListener("mouseenter", this._boundFns.mouseEnter), this._doc.removeEventListener("mouseleave", this._boundFns.mouseLeave);
            }
          }], o && t(i.prototype, o), Object.defineProperty(i, "prototype", {
            writable: !1
          }), e;
        }();
      e.exports = i;
    }
  }, t = {}, function s(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = t[n] = {
      exports: {}
    };
    return e[n](o, o.exports, s), o.exports;
  }(64);
  var e, t;
});